import React from 'react'

export const SnsLoginContentsArea = ({children}) => {
  return (
    <div>
      <div
        style={{
          textAlign: "center",
        }}
      >
        {children}
      </div>
    </div>
  )
}
